jQuery.fn.mailme = function() {
    var at = / at /;
    var dot = / dot /g;
    this.each( function() {
        var addr = jQuery(this).text().replace(at, "<span>@</span>").replace(dot, ".");
        var link = jQuery(this).text().replace(at, "@").replace(dot, ".");
        link = $.trim(link);
        var title = jQuery(this).attr('title');

        $(this)
            .after('<a href="mailto:' + link + '" title="' + title + '">' + addr + '</a>')
            .remove();
    });
};